export default __webpack_public_path__ + "static/media/close.c2564d2e.svg";